import React from 'react';
import { Spinner } from 'react-bootstrap';
import classNames from 'classnames';
import styles from './styles.module.scss';

interface Props {
  centered?: boolean;
  message?: string;
  size?: 'sm';
}

const LoadingSpinner: React.FC<Props> = ({ centered = false, message, size }) => {
  const mainClasses = classNames({
    [styles.loadingContainer]: true,
    [styles.centered]: centered
  });
  return (
    <div className={mainClasses}>
      <Spinner animation="border" role="status" variant="primary" size={size} />
      {message && <p>{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
